import React, { useDebugValue, useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import { useNavigate , useParams} from 'react-router-dom';
import Select from 'react-select';
import $ from "jquery";
import { getAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateFormat } from "../../services/Util";
import { RotatingLines } from "react-loader-spinner";
import images from "../../images";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";

export default function CustomVendorDirectory() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const params = useParams();

    const [vendorData, setVendorData] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [certifications, setCertifications] = useState([]);
    const [supportedFileTypes, setSupportedFileTypes] = useState([]);
    const [languagePairs, setLanguagePairs] = useState([]);
    const [topLanguagePairs, setTopLanguagePairs] = useState([]);
    const [preferredVendorDepartments, setPreferredVendorDepartments] = useState([]);
    const [unassignedDepartments, setUnassignedDepartments] = useState([]);
    const [globalOverlay, showGlobalOverlay] = useState(false);
    const [groupsToAdd, setGroupsToAdd] = useState([]);
    const [groupsToRemove, setGroupsToRemove] = useState([]);
    const editButtonRef = useRef()

    const showIntendentModel = (e) => {
      document.body.classList.add("modal-open");
      editButtonRef.current = e.target;
      setTimeout(() => {
        $(".first-focus").trigger("focus");
        $("#addDepartment").on("keydown", function (e) {
          if (e.key === Constants.TAB) {
            if (e.shiftKey === true) {
              e.preventDefault();
              $("#saveId").trigger("focus");
            }
          }
        });
        $(".inner-lightbox-panel").on("keydown", function (e) {
          let allAreFalse = true;
          $('#addDepartment').each(function() {
            if ($(this).find('input').attr('aria-expanded') !== 'false') {
              allAreFalse = false;
              return false;
            }
          });
          if (e.key === Constants.ESCAPE && allAreFalse) {
            hideIntendentModel();
          }
        });
      }, 500);
      fetchVendorData();

      $(".global-dropdown-block .global-dropdown-select").removeClass('hide')

    }

    const hideIntendentModel = () => {
      document.body.classList.remove("modal-open");
      if($(editButtonRef.current).length){
      $(editButtonRef.current).parent().trigger('focus')};
      $(".global-dropdown-block .global-dropdown-select").addClass('hide')
      $('.name-edit.inline-flex').trigger('focus')
   };

   const hideIntendentModelonKeydown =(e)=>{
    if (e.keyCode == Constants.ESC_KEYCODE) {
      hideIntendentModel();
    }
   }

  const navigate = useNavigate();
  const backRef = useRef();
  $(document).on("click",".add-multidepart button",function() {
    $(this).addClass('focusAdd');
  });
 $(document).on("click",".modal-footer .btn",function() {
   $('.focusAdd').trigger('focus');
   $('.add-multidepart button').removeClass('focusAdd');
});

useEffect(() => {

  getAxiosResponse(APIUrls.VENDOR_CERTIFICATIONS(params.id))
  .then((res) => {
    setCertifications(res.data.data);
  })

  getAxiosResponse(APIUrls.VENDOR_SUPPORTED_FILE_TYPES(params.id))
  .then((res) => {
    setSupportedFileTypes(res.data.data);
  })

  getAxiosResponse(APIUrls.VENDOR_LANGUAGE_PAIRS(params.id))
  .then((res) => {
    setLanguagePairs(res.data.data);
  })

  fetchVendorData();

}, [])

const fetchVendorData = () => {
  showGlobalOverlay(true);
  Promise.all([
    getAxiosResponse(APIUrls.ALL_DEPARTMENT),
    getAxiosResponse(APIUrls.CUSTOMER_PREFERRED_VENDORS),
    getAxiosResponse(APIUrls.VENDOR_BY_ID(params.id)),
   ]).then(async ([allDepartments, customerPreferredVendors, vendorById]) => {
      if(customerPreferredVendors?.data?.code === 200) {
        let vendorDetails = customerPreferredVendors.data.data.filter((pv) => pv.vendor.id === vendorById.data.data.resource.id);
        let depts = vendorDetails.map((vendData) => vendData.userGroup);
        vendorById.data.data.resource.userGroups = depts;
        setVendorData(vendorById.data.data.resource);
        setTopLanguagePairs(vendorById.data.data.displayName[0]);
        setIndustries(vendorById.data.data.displayName[1]);

        let preferredDepartments = vendorById.data.data.resource?.userGroups?.map((userGroup) => userGroup.id);
        let unassignedDepts = [{label: `${t('select_one_department')}`, value: Constants.BLANK}];
        allDepartments.data.data.map((ug) => {
          if(!preferredDepartments.includes(ug.id)) {
            unassignedDepts.push({label: ug.name, value: ug.id})
          }
        });
        setUnassignedDepartments(unassignedDepts);
        setPreferredVendorDepartments(vendorById.data.data.resource?.userGroups)
      }
      showGlobalOverlay(false);
   })
   .catch((err) => {
    console.error(err);
    showGlobalOverlay(false);
  })
}

const handleDepartmentSelection = (value) => {
  if(value.value !== Constants.BLANK) {
    let deptToBeAdded = {
      applicationVersion : "",
      createdDate : "",
      id : value.value,
      name : value.label,
      path : "",
      systemGroup : false
    }
    let isPreferred = vendorData?.userGroups?.filter((ug) => ug.id === value.value).length === 1;
    if(!isPreferred) {
      setGroupsToAdd([...groupsToAdd, value.value]);
    }
    if(groupsToRemove.includes(value.value)) {
      setGroupsToRemove(groupsToRemove.filter((group) => group !== value.value))
    }
    setPreferredVendorDepartments([...preferredVendorDepartments, deptToBeAdded]);
    setUnassignedDepartments(unassignedDepartments.filter((dept) => dept.value !== value.value));
  }
}

const removeDepartment = (userGroup) => {
  let isPreferred = vendorData?.userGroups?.filter((ug) => ug.id === userGroup.id).length === 1;
  if(isPreferred) {
    setGroupsToRemove([...groupsToRemove, userGroup.id]);
  }
  if(groupsToAdd.includes(userGroup.id)) {
    setGroupsToAdd(groupsToAdd.filter((group) => group !== userGroup.id))
  }
  setUnassignedDepartments([...unassignedDepartments, {label: userGroup.name, value: userGroup.id}])
  setPreferredVendorDepartments(preferredVendorDepartments.filter((group) => group.id !== userGroup.id));

  const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1){
				selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if($(document.activeElement).is(':last-child')){
			$(document.activeElement).closest(".inner-lightbox-panel").find('.global-dropdown-select input:first-of-type').trigger('focus');
		}
}

const handleKeyOkflow = (event) => {
  if (event.key === Constants.TAB) {
    if (event.shiftKey === false) {
      event.preventDefault();
      $(".cw__input").trigger("focus");
    }
  }
};

const removeDepartmentonKeydown =(event, userGroup) => {
  if (event.key === Constants.ENTER) {
    removeDepartment(userGroup);
  }
}

const updatePreferredVendors = () => {
  let groupsToBeUpdated = {
    groupsToAdd : groupsToAdd,
    groupsToRemove : groupsToRemove,
    id : -1
  }
  putAxiosResponse(APIUrls.UPDATE_PREFERRED_VENDORS(params.id), groupsToBeUpdated)
  .then((res) => {
    if(res.data?.data?.statusCodeValue === 200) {
      hideIntendentModel();
      fetchVendorData();
    }
  })
}

useEffect(() => {
  $('.lastdisable').trigger('focus');
}, []);

const crumbs = [
  {label:'Vendor', url:'vendor/customer-vendor/'},
  {label:'Vendor Directory', url:''},
 ];

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
          <Breadcrumb crumbs={ crumbs } />
            <div className="customer-vendor-page">
              <div className="project-heading userprofile-heading">
                <h3 className="flex">
                   {vendorData.name}</h3>
                <span>
                  Member of the OPAL-Marketing Marketplace since {dateFormat(vendorData.createdDate, Constants.DATE_MONTH_YEAR)}
                </span>
              </div>
              <div className="white-bg mar-bot50">
              <div className="customer-vendor-content">
                   <ul className="customer-vendor-list">
                     <li>
                       <div className="image-block">
                         <figure><img src={vendorData?.logoPath !== Constants.BLANK ? vendorData?.logoPath : images.DEFAULT_VENDOR_LOGO} alt={vendorData?.name} /></figure>
                       </div>
                       <div className="desc-content">
                          <div><a className="readonly"><strong>{vendorData.name}</strong></a></div>
                          <p>{vendorData.description}</p>
                          <h5>Preferred by:</h5>
                          <div className="preferby flex">
                            <div className="multiselect-output flex">
                              {vendorData?.userGroups?.map((userGroup, index) => {
                                return (
                                  <span>{userGroup.name}<span aria-hidden="true">{index !== vendorData?.userGroups?.length-1 ? "," : ""}</span>&nbsp;</span>
                                )
                              })}
                            </div>
                            <button aria-label={translate("cust_vendor.vendor_detail_edit_department")} className="name-edit inline-flex"
                             onClick={(e)=>showIntendentModel(e)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="17"
                                viewBox="0 0 18 17"
                                fill="none"
                               
                                className="aaa-change-icon"
                              >
                                <path
                                  d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                                  fill="#1D4ED8"
                                />
                              </svg>
                            </button>
                         </div>

                         <div className="contact-info flex">
                           <div className="contact-info-list">
                              <strong>Contact Name</strong>
                              <span>{vendorData?.name ? vendorData?.name : Constants.NOT_APPLICABLE}</span>
                           </div>
                           <div className="contact-info-list">
                              <strong>Email</strong>
                              <span>{vendorData?.contactEmail ? vendorData?.contactEmail : Constants.NOT_APPLICABLE}</span>
                           </div>
                           <div className="contact-info-list">
                              <strong>Address</strong>
                              <address>
                              {(vendorData?.profileAddress1 === Constants.BLANK && vendorData?.profileAddress2 === Constants.BLANK && vendorData?.profileCity === Constants.BLANK) && <span>{Constants.NOT_APPLICABLE}</span>}
                              <span>{vendorData?.profileAddress1}<br aria-hidden="true"/>{vendorData?.profileAddress2}<br aria-hidden="true"/>{vendorData?.profileCity}</span>
                              </address>
                           </div>
                           <div className="contact-info-list">
                              <strong>Company Phone</strong>
                              <span>{vendorData?.profilePhone ? vendorData?.profilePhone : Constants.NOT_APPLICABLE}</span>
                           </div>
                         </div>
                         <div className="mar-top30">
                            <h5>Certifications:</h5>
                            <p>
                              {certifications.length !== 0 ? certifications.map((certification, index) => {
                                return certification.name + (index !== certifications.length-1 ? ", " : " ")
                              }) : Constants.NOT_APPLICABLE}
                            </p>
                            <h5>Industries:</h5>
                            <p>
                              {industries.length !== 0 ? industries.map((industry, index) => {
                                return industry.display + (index !== industries.length-1 ? ", " : " ")
                              }) : Constants.NOT_APPLICABLE}
                            </p>
                            <h5>Top Language Pairs:</h5>
                            {Object.keys(topLanguagePairs).length !== 0 ? Object.keys(topLanguagePairs).map((pair) => {
                              return (
                                  <p><strong>{pair}</strong> to :&nbsp;
                                  {topLanguagePairs[pair].map(
                                    (targets, index) => {
                                      return <span>{targets.target.display + (index !== topLanguagePairs[pair].length-1 ? ", " : " ")}</span>;
                                    }
                                  )}
                                  </p>
                              );
                            }) : <p>{Constants.NOT_APPLICABLE}</p>}
                            <h5>Language Pairs:</h5>
                            {languagePairs !== undefined && Object.keys(languagePairs).length !== 0 ? Object.keys(languagePairs).map((pair) => {
                              return (
                                  <p><strong>{pair}</strong> to :&nbsp;
                                  {languagePairs[pair].map(
                                    (targets, index) => {
                                      return <span>{targets.target.display + (index !== languagePairs[pair].length-1 ? ", " : " ")}</span>;
                                    }
                                  )}
                                  </p>
                              );
                            }) : <p>{Constants.NOT_APPLICABLE}</p>}
                            <h5>Supported File Types:</h5>
                            <p>
                              {supportedFileTypes.length !== 0 ?supportedFileTypes.map((supportedFileType, index) => {
                                return supportedFileType.extension + (index !== supportedFileTypes.length-1 ? ", " : " ")
                              }) : Constants.NOT_APPLICABLE}
                            </p>
                         </div>

                       </div>
                     </li>
                  </ul>
                 </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className='lightbox-panel' aria-labelledby="renamelabel" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel pb-0">
                <div className="modal-header flex padd-lr">
                <h5 id="renamelabel">Department Preference</h5>
                </div>
                <div className="lightbox-content padd-22">
                  <h6 className="mar-bot20">For which department should <span>{vendorData.name}</span> be preferred?</h6>
                  <div className="flex wrap-dropdown mb-0">
                    <div className="global-dropdown-block">
                        <label>Department(s)</label>
                        <Select
                            classNamePrefix='cw'
                            className="global-dropdown-select hide"
                            aria-label="Department"
                            id="addDepartment"
                            menuShouldScrollIntoView={false}
                            closeMenuOnSelect={true} 
                            options={unassignedDepartments}
                            value={{
                              label: `${t('select_one_department')}`,
                              value: Constants.BLANK,
                            }}
                            onChange={(value) => handleDepartmentSelection(value)}
                        />
                        <div className="multiselect-output flex">
                          {preferredVendorDepartments?.map((userGroup) => {
                            return (
                              <button onClick={(e) => removeDepartment(userGroup)}
                              onKeyDown={(e)=> removeDepartmentonKeydown(userGroup)}
                               aria-label={"Remove " + userGroup.name}>
                                <strong>{userGroup.name}</strong>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                              </button>
                            )
                          })}
                        </div>
                    </div>
                    </div>
                </div>
       
                <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus" onClick={hideIntendentModel} onKeyDown={(e)=>hideIntendentModelonKeydown}>Cancel</button>
                    <button id="saveId" className="btn btn-bold active" onClick={updatePreferredVendors} onKeyDown={handleKeyOkflow}>Save</button>
                </div>
                </div>		
        </div>
        <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
          <div className="gb-loader">
            <RotatingLines
              strokeColor="#0096FF"
              strokeWidth="5"
              width="196"
              visible={true}
            />
          </div>
      </div>
    </div>
  );
}
